export { ZendeskArticle, type ZendeskArticleProps } from "./ZendeskArticle";
